import { dotsService } from '@/api'
import { CARD_CREATE } from '@/common/constants'
import { detach } from '@/plugins/detach'
import active from '@/store/modules/dots/active'
import snapshot from '@/lib/snapshot'

const initialState = () => ({
  all: [],
  projectCount: 0,
  fresh: null
})

export default {
  namespaced: true,
  state: initialState(),
  getters: {
    count: state => state.projectCount
  },
  actions: {
    new({ commit }, payload) {
      const { dot } = payload
      commit('dots/active/core/assign', dot, { root: true })
      commit(
        'dots/active/card/assign',
        {
          id: CARD_CREATE,
          name: '',
          desc: '',
          list_id: null,
          priority_id: null,
          type_id: null,
          assigned_to_user_id: null
        },
        { root: true }
      )
      commit('dots/active/system/assign', null, { root: true })

      return true
    },
    async create({ dispatch, rootState }, payload) {
      delete payload.id

      // add snapshot
      console.log('ADD BACK SNAPSHOT')
      // payload.snapshot = await snapshot.run()

      console.log('snapshot!', snapshot)
      await dispatch('browser/assign', null, { root: true })
      return dotsService.create({
        ...rootState.dots.active,
        card: {
          ...payload,
          project_id: rootState.provider.projects.active.id
        }
      })
    },
    async createGeneric({ dispatch, rootState }, payload) {
      return dotsService.create({
        core: {
          mode: 'CARD_MODE_GENERIC'
        },
        card: {
          ...payload,
          project_id: rootState.provider.projects.active.id
        }
      })
    },
    update({ rootState }, data) {
      const { id, payload } = data
      return dotsService.update(id, payload)
    },
    async get({ commit, state, rootState }, id) {
      try {
        // Return created object from store
        if (id === CARD_CREATE) {
          return {
            card: detach(rootState.dots.active.card)
          }
        }

        // Else Look in existing store
        // TODO: use eTags or something else
        let dot = state.all.find(d => d.id === id || d.id === parseInt(id))

        // Else Fetch from provider
        if (!dot) {
          dot = await dotsService.get(id, {
            query: {
              $eager: 'created_by_user'
            }
          })

          console.log('DOT READY', dot)

          // Add to store
          commit('add', dot)
        }

        return detach(dot)
      } catch (err) {
        console.error(err)
      }
    },
    async find({}, query) {
      console.log('find query', query)
      return dotsService.find({
        query
      })
    },
    async findByPage({ commit, rootState }) {
      const { id } = rootState.pages.active
      const result = await dotsService.find({
        query: {
          page_id: id
        }
      })

      return result
    },
    async findByProject({ commit, rootState }) {
      const { id } = rootState.provider.projects.active
      const result = await dotsService.find({
        query: {
          provider_project_id: id
        }
      })
      commit('projectCount', result.length)
      console.log('project result', result)
      return result
    }
  },
  mutations: {
    add(state, payload) {
      const foundIndex = state.all.findIndex(c => c.id === payload.id)
      if (foundIndex !== -1) return state.all.splice(foundIndex, 1, payload)
      state.all.push(payload)
    },
    fresh(state, id) {
      state.fresh = id
    },
    projectCount(state, newCount) {
      state.projectCount = newCount
    }
  },
  modules: {
    active
  }
}
